import TransactionsList from '@/views/Admin/TransactionsList/TransactionsList.vue';
import { Route } from '../route.model';

const adminTransactionsList = new Route(
  '/admin/transactions',
  'admin_transactions_list',
  TransactionsList,
  {
    requiresAuth: true,
    superRoot: true,
    navbar: {
      name: 'Loyalty Transactions', // TODO apply i18n
      icon: 'reward-ratio'
    },
    zendesk: {
      disabled: true
    }
  }
);

export { adminTransactionsList };
export default adminTransactionsList;
